import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Input, message } from 'antd';
import { graphql, compose } from 'react-apollo';
import validationRegex from '@eumentis-cloud/js-validation-regex';
import { addressTextAreaFormatValue } from '../utils/globals';

import CreateEdlCollegeMutation from '../graphql/mutations/createEdlCollegeMutation.graphql';

const FormItem = Form.Item;
const { TextArea } = Input;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 4 },
    lg: { span: 4 },
    xl: { span: 3 },
    xxl: { span: 3 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 16 },
    lg: { span: 16 },
    xl: { span: 6 },
    xxl: { span: 6 },
  },
};

class NewEdlCollegeForm extends Component {
  state = {
    submittingForm: false,
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({
      submittingForm: true,
    });

    const { form, mutate, history } = this.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        mutate({ variables: { ...values, address: addressTextAreaFormatValue(values.address) } })
          .then(() => {
            this.setState({
              submittingForm: false,
            });
            history.goBack();
            message.success('New college created!');
          })
          .catch((err1) => {
            this.setState({
              submittingForm: false,
            });
            console.log(err1);
            message.error(err1.message);
          });
      } else {
        this.setState({
          submittingForm: false,
        });
      }
    });
  };

  render() {
    const { submittingForm } = this.state;
    const { form } = this.props;
    const { getFieldDecorator } = form;

    return (
      <div className="contentBox">
        <h2>Add new college</h2>
        <Form layout="horizontal" onSubmit={this.handleSubmit}>
          <FormItem label="College Name" hasFeedback {...formItemLayout}>
            {getFieldDecorator('name', {
              rules: [{ required: true, message: 'Field is required!' }],
            })(<Input disabled={submittingForm} />)}
          </FormItem>
          <FormItem label="Street Address" {...formItemLayout}>
            {getFieldDecorator('address')(<TextArea autosize={{ minRows: 2, maxRows: 4 }} disabled={submittingForm} />)}
          </FormItem>
          <FormItem label="City" {...formItemLayout}>
            {getFieldDecorator('city')(<Input disabled={submittingForm} />)}
          </FormItem>
          <FormItem label="State" {...formItemLayout}>
            {getFieldDecorator('state')(<Input disabled={submittingForm} />)}
          </FormItem>
          <FormItem label="Pincode" hasFeedback {...formItemLayout}>
            {getFieldDecorator('pincode', {
              rules: [{ pattern: validationRegex.pincode, message: 'Incorrect value' }],
            })(<Input disabled={submittingForm} />)}
          </FormItem>
          <FormItem>
            <Button type="primary" htmlType="submit" loading={submittingForm}>
              Submit
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

NewEdlCollegeForm.propTypes = {
  form: PropTypes.shape({
    getFieldDecorator: PropTypes.func,
    validateFieldsAndScroll: PropTypes.func,
    resetFields: PropTypes.func,
  }).isRequired,
  mutate: PropTypes.func.isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
  }).isRequired,
};

export default compose(
  graphql(CreateEdlCollegeMutation),
  Form.create(),
)(NewEdlCollegeForm);



// WEBPACK FOOTER //
// ./src/forms/NewEdlCollegeForm.jsx